import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const PROFILE_CENTER: AppRouteRecordRaw = {
  path: '/profile-center',
  name: 'ProfileCenter',
  component: DEFAULT_LAYOUT,
  redirect: '/profile-center/setting',
  meta: {
    locale: 'menu.profileCenter',
    requiresAuth: true,
    icon: 'icon-settings',
    order: 10,
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'setting',
      name: 'ProfileCenterSetting',
      component: () => import('@/views/user/setting/index.vue'),
      meta: {
        locale: 'menu.profileCenter',
        requiresAuth: true,
        roles: ['*'],
        activeMenu: 'ProfileCenter',
      },
    },
  ],
};

export default PROFILE_CENTER;
